import React, { useEffect, useState } from 'react';
import { LOGO_URL, NAV_ITEMS } from '../data/mock';
import { ArrowUpRight, Menu, X } from 'lucide-react';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'backdrop-blur-md bg-black/55 border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[68px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="SAMZ Academy" className="h-9 w-9 object-contain" />
          <span className="font-display text-[15px] tracking-wide hidden sm:block">SAMZ Academy</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_ITEMS.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className="text-[13.5px] text-white/70 hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href="#signup" className="btn-jade !py-2.5 !px-5 !text-[13px]">
            Sign Up
            <ArrowUpRight size={16} />
          </a>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen((v) => !v)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_ITEMS.map((n) => (
              <a key={n.label} href={n.href} onClick={() => setOpen(false)} className="text-white/80 text-[15px]">
                {n.label}
              </a>
            ))}
            <a href="#signup" onClick={() => setOpen(false)} className="btn-jade w-fit">
              Sign Up <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
